import { render } from "./TypeTopNav.vue?vue&type=template&id=99792a80"
import script from "./TypeTopNav.vue?vue&type=script&lang=js"
export * from "./TypeTopNav.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/Upwork/kaz/plus studio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__